import React from 'react'
import CategoriesNotes from './CategoriesNotes'
import { Nav, Tab } from 'react-bootstrap'
import { surveyType } from '@abroad/components/src/helper/common'

const ReviewAssessmentResults = ({
  logs,
  sessionLogs,
  saveLogHandler = () => {},
  disabled = false,
  clientSurveyType,
}) => {
  const pages = []

  if (clientSurveyType === surveyType.WISDOM) {
    pages.push(
      { name: 'Wisdom Assessment', type: 'wisdom' },
      { name: 'Purpose & Life Alignment', type: 'purposeAndLife' },
      { name: 'Awareness Assessment', type: 'awareness' },
    )
  } else if (clientSurveyType === surveyType.AWARENESS) {
    const hasWisdom = logs?.data?.wisdom && logs.data.wisdom.length > 0

    pages.push(
      { name: 'Awareness Assessment', type: 'awareness' },
      { name: 'Purpose & Life Alignment', type: 'purposeAndLife' },
      hasWisdom
        ? { name: 'Wisdom Assessment', type: 'wisdom' }
        : { name: 'True Prosperity Assessment', type: 'prosperity' },
    )
  } else if (clientSurveyType === surveyType.PROSPERITY) {
    pages.push(
      { name: 'True Prosperity Assessment', type: 'prosperity' },
      { name: 'Purpose & Life Alignment', type: 'purposeAndLife' },
      { name: 'Awareness Assessment', type: 'awareness' },
    )
  } else {
    pages.push(
      { name: 'Awareness Assessment', type: 'awareness' },
      { name: 'Purpose & Life Alignment', type: 'purposeAndLife' },
      { name: 'True Prosperity Assessment', type: 'prosperity' },
    )
  }

  let defaultTab
  if (clientSurveyType && clientSurveyType === surveyType.AWARENESS) {
    defaultTab = 'Awareness Assessment'
  } else if (clientSurveyType && clientSurveyType === surveyType.WISDOM) {
    defaultTab = 'Wisdom Assessment'
  } else if (clientSurveyType && clientSurveyType === surveyType.PROSPERITY) {
    defaultTab = 'True Prosperity Assessment'
  } else {
    // Default to first tab when no survey type is set
    defaultTab = pages.length > 0 ? pages[0].name : ''
  }
  return (
    <div>
      <h3 className='mb-point-75 font-open-sans font-22 font-bold review-title'>
        Review Assessment Results (30 minutes)
      </h3>
      <p className='s6 review-description'>
        Starting with the lowest scores, we encourage you to ask the prompt
        questions for each category to uncover the mindsets and behaviors that
        are driving these results and to input key notes. In a typical growth
        plan session, coaches normally get through 3 to 7 categories.
      </p>

      <Tab.Container
        key={clientSurveyType || 'default'}
        defaultActiveKey={defaultTab}>
        <div className='header-tabs nav border-bottom-none growth-tabs'>
          <Nav>
            {pages.map((page, index) => (
              <Nav.Item key={index}>
                <Nav.Link eventKey={page.name}>{page.name}</Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
        <Tab.Content>
          {pages.map((page, index) => (
            <Tab.Pane key={index} eventKey={page.name}>
              <CategoriesNotes
                logs={logs.logs}
                sessionLogs={sessionLogs}
                saveLogHandler={saveLogHandler}
                disabled={disabled}
                type={page.type}
              />
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    </div>
  )
}

export default ReviewAssessmentResults
